<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 50 50"
  style="enable-background: new 0 0 50 50"
  xml:space="preserve"
>
  <style type="text/css">
    .st0 {
      display: none;
    }
    .st1 {
      display: inline;
      fill: currentColor;
    }
    .st2 {
      display: inline;
      fill: #a4a4a3;
    }
    .st3 {
      display: inline;
      fill: #d8d8d8;
    }
    .st4 {
      display: inline;
      opacity: 0.6;
      fill: currentColor;
    }
    .st5 {
      display: inline;
    }
    .st6 {
      fill: currentColor;
    }
    .st7 {
      fill: #d8d8d8;
    }
  </style>
  <g class="st0">
    <path
      class="st1"
      d="M6,47.5H3c-0.3,0-0.5-0.2-0.5-0.5V3c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5v44
		C6.5,47.3,6.3,47.5,6,47.5z"
    />
    <path
      class="st1"
      d="M2.5,47v-3c0-0.3,0.2-0.5,0.5-0.5h44c0.3,0,0.5,0.2,0.5,0.5v3c0,0.3-0.2,0.5-0.5,0.5H3
		C2.7,47.5,2.5,47.3,2.5,47z"
    />
    <path
      class="st1"
      d="M9.9,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V29.8c0-0.3-0.2-0.5-0.4-0.5H9.9c-0.2,0-0.4,0.2-0.4,0.5V40
		C9.5,40.3,9.7,40.5,9.9,40.5z"
    />
    <path
      class="st1"
      d="M14,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5v-3.2c0-0.3-0.2-0.5-0.4-0.5H14c-0.2,0-0.4,0.2-0.4,0.5V40
		C13.6,40.3,13.8,40.5,14,40.5z"
    />
    <path
      class="st1"
      d="M18.2,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V22.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C17.8,40.3,17.9,40.5,18.2,40.5z"
    />
    <path
      class="st1"
      d="M22.3,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V6c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5v34
		C21.9,40.3,22.1,40.5,22.3,40.5z"
    />
    <path
      class="st1"
      d="M26.4,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V12.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C26,40.3,26.2,40.5,26.4,40.5z"
    />
    <path
      class="st1"
      d="M30.5,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V27.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C30.1,40.3,30.3,40.5,30.5,40.5z"
    />
    <path
      class="st1"
      d="M34.6,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5v-7.2c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C34.2,40.3,34.4,40.5,34.6,40.5z"
    />
    <path
      class="st1"
      d="M38.8,40.5H40c0.2,0,0.4-0.2,0.4-0.5V17.8c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5V40
		C38.4,40.3,38.6,40.5,38.8,40.5z"
    />
    <path
      class="st1"
      d="M42.9,40.5h1.2c0.2,0,0.4-0.2,0.4-0.5V27c0-0.3-0.2-0.5-0.4-0.5h-1.2c-0.2,0-0.4,0.2-0.4,0.5v13
		C42.5,40.3,42.7,40.5,42.9,40.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M18.5,28v12c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V28c0-0.3,0.2-0.5,0.5-0.5h8
		C18.3,27.5,18.5,27.7,18.5,28z"
    />
    <path
      class="st1"
      d="M44.5,23v17c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V23c0-0.3,0.2-0.5,0.5-0.5h8
		C44.3,22.5,44.5,22.7,44.5,23z"
    />
    <path
      class="st1"
      d="M31.5,18v22c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V18c0-0.3,0.2-0.5,0.5-0.5h8
		C31.3,17.5,31.5,17.7,31.5,18z"
    />
    <path
      class="st1"
      d="M9.5,18v-5.3c0-0.2,0.1-0.3,0.2-0.4l11.8-9.7c0.2-0.1,0.4-0.1,0.6,0l16.6,9.7c0.2,0.1,0.4,0.1,0.6,0l7.5-6.2
		c0.3-0.3,0.8,0,0.8,0.4v5c0,0.2-0.1,0.3-0.2,0.4l-8.1,6.5c-0.2,0.1-0.4,0.1-0.6,0L22.1,8.6c-0.2-0.1-0.4-0.1-0.6,0.1l-11.2,9.7
		C10,18.6,9.5,18.4,9.5,18z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M22,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,30.5,22,30.7,22,31
		z"
    />
    <path
      class="st2"
      d="M22,6v5c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,5.5,22,5.7,22,6z"
    />
    <path
      class="st1"
      d="M34.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,5.5,34.5,5.7,34.5,6z"
    />
    <path
      class="st2"
      d="M22,14v14c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V14c0-0.3-0.2-0.5-0.5-0.5h-9
		C22.2,13.5,22,13.7,22,14z"
    />
    <path
      class="st2"
      d="M34.5,18v22c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V18c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,17.5,34.5,17.7,34.5,18z"
    />
    <path
      class="st2"
      d="M9.5,25v15c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V25c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,24.5,9.5,24.7,9.5,25z"
    />
    <path
      class="st1"
      d="M9.5,6v16c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C9.7,5.5,9.5,5.7,9.5,6z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M22,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,30.5,22,30.7,22,31
		z"
    />
    <path
      class="st2"
      d="M22,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C22.2,18,22,18.2,22,18.5z"
    />
    <path
      class="st1"
      d="M22,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C22.2,5.5,22,5.7,22,6z"
    />
    <path
      class="st2"
      d="M9.5,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,30.5,9.5,30.7,9.5,31z"
    />
    <path
      class="st1"
      d="M9.5,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C9.7,18,9.5,18.2,9.5,18.5z"
    />
    <path
      class="st2"
      d="M9.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9C9.7,5.5,9.5,5.7,9.5,6z"
    />
    <path
      class="st1"
      d="M34.5,31v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,30.5,34.5,30.7,34.5,31z"
    />
    <path
      class="st2"
      d="M34.5,18.5v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5v-9c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,18,34.5,18.2,34.5,18.5z"
    />
    <path
      class="st2"
      d="M34.5,6v9c0,0.3,0.2,0.5,0.5,0.5h9c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-9
		C34.7,5.5,34.5,5.7,34.5,6z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <rect x="9.5" y="2.5" class="st3" width="38" height="38" />
    <polygon
      class="st2"
      points="9.5,40.5 9.5,14.8 19.2,11.8 30.2,17.5 39.7,9.5 47.5,13.1 47.5,40.5 	"
    />
    <polygon
      class="st1"
      points="47.5,22.7 47.5,40.5 9.5,40.5 9.5,30.3 14.6,25.9 25,32.7 34.9,25.9 41.6,28.2 	"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <polygon
      class="st3"
      points="9.5,40.5 9.5,13.7 13.9,10.7 21.4,12.7 33.5,6.6 42.2,8.6 47.5,6 47.5,40.5 	"
    />
    <polygon
      class="st2"
      points="9.5,40.5 9.5,20 21.9,21.5 28,14.5 37.7,17.6 47.5,10.7 47.5,40.5 	"
    />
    <polygon
      class="st1"
      points="47.5,25.6 47.5,40.5 9.5,40.5 9.5,30.2 17.4,28.8 26.2,31.8 34.6,24.7 41.5,28.2 	"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v2.5V47c0,0.3,0.2,0.5,0.5,0.5h0.5
		c0,0,0,0,0,0h2c0,0,0,0,0,0H47c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <polygon
      class="st3"
      points="9.5,40.5 9.5,24.2 13.4,21.3 26.3,25 37.9,13.8 47.5,11.9 47.5,40.5 	"
    />
    <polygon
      class="st4"
      points="47.5,15.1 47.5,40.5 9.5,40.5 9.5,27.9 16.1,25.5 23.3,13.7 30.9,10.7 40.1,21.8 	"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M43.7,10.7L28.9,25.4c-0.2,0.2-0.5,0.2-0.7,0l-7.1-7.1c-0.2-0.2-0.5-0.2-0.7,0L9.6,29.2
		c-0.1,0.1-0.1,0.2-0.1,0.4v6.1c0,0.4,0.5,0.7,0.8,0.4l10.1-10.1c0.2-0.2,0.5-0.2,0.7,0l7.1,7.1c0.2,0.2,0.5,0.2,0.7,0l15.4-15.4
		c0.1-0.1,0.1-0.2,0.1-0.4v-6.1C44.5,10.6,44,10.4,43.7,10.7z"
    />
  </g>
  <g class="st0">
    <path class="st1" d="M26.5,2.5v19l13.9-13C36.7,5.1,31.8,2.9,26.5,2.5z" />
    <path
      class="st1"
      d="M23.7,25.7C23.7,25.7,23.7,25.7,23.7,25.7c-0.1-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1
		c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1V2.5C11.8,3.3,2.5,13.1,2.5,25c0,12.4,10.1,22.5,22.5,22.5
		c3.6,0,6.9-0.8,9.9-2.3L23.7,25.7z"
    />
    <path
      class="st1"
      d="M42.4,10.7L26.9,25.3l10.6,18.4c6-4,10-10.9,10-18.7C47.5,19.6,45.6,14.6,42.4,10.7z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st5">
      <path
        class="st6"
        d="M44,18.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
			C44.5,18.7,44.3,18.5,44,18.5z M42.5,25c0,0.3-0.2,0.5-0.5,0.5h-5.7c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V25z"
      />
      <path
        class="st6"
        d="M44,31.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
			C44.5,31.7,44.3,31.5,44,31.5z M42.5,38c0,0.3-0.2,0.5-0.5,0.5H20.6c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V38z"
      />
      <path
        class="st6"
        d="M44,5.5H10C9.7,5.5,9.5,5.7,9.5,6v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5V6
			C44.5,5.7,44.3,5.5,44,5.5z M42.5,12c0,0.3-0.2,0.5-0.5,0.5H31.2c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H42
			c0.3,0,0.5,0.2,0.5,0.5V12z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st5">
      <path
        class="st6"
        d="M22.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8
			C22.7,5.5,22.5,5.7,22.5,6z M29,7.5c0.3,0,0.5,0.2,0.5,0.5v5.7c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8
			c0-0.3,0.2-0.5,0.5-0.5H29z"
      />
      <path
        class="st6"
        d="M35.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8
			C35.7,5.5,35.5,5.7,35.5,6z M42,7.5c0.3,0,0.5,0.2,0.5,0.5v21.4c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8
			c0-0.3,0.2-0.5,0.5-0.5H42z"
      />
      <path
        class="st6"
        d="M9.5,6v34c0,0.3,0.2,0.5,0.5,0.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8C9.7,5.5,9.5,5.7,9.5,6z
			 M16,7.5c0.3,0,0.5,0.2,0.5,0.5v10.8c0,0.3-0.2,0.5-0.5,0.5h-4c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H16z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M44,18.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h34c0.3,0,0.5-0.2,0.5-0.5v-8
		C44.5,18.7,44.3,18.5,44,18.5z M42.5,25c0,0.3-0.2,0.5-0.5,0.5H30c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5h12
		c0.3,0,0.5,0.2,0.5,0.5V25z"
    />
    <path
      class="st1"
      d="M34,31.5H10c-0.3,0-0.5,0.2-0.5,0.5v8c0,0.3,0.2,0.5,0.5,0.5h24c0.3,0,0.5-0.2,0.5-0.5v-8
		C34.5,31.7,34.3,31.5,34,31.5z M32.5,38c0,0.3-0.2,0.5-0.5,0.5H20c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5h12
		c0.3,0,0.5,0.2,0.5,0.5V38z"
    />
    <path
      class="st1"
      d="M27,5.5H10C9.7,5.5,9.5,5.7,9.5,6v8c0,0.3,0.2,0.5,0.5,0.5h17c0.3,0,0.5-0.2,0.5-0.5V6
		C27.5,5.7,27.3,5.5,27,5.5z M25.5,12c0,0.3-0.2,0.5-0.5,0.5h-4.5c-0.3,0-0.5-0.2-0.5-0.5V8c0-0.3,0.2-0.5,0.5-0.5H25
		c0.3,0,0.5,0.2,0.5,0.5V12z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M23,40.5h8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v34
		C22.5,40.3,22.7,40.5,23,40.5z M24.5,8c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v12c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V8z"
    />
    <path
      class="st1"
      d="M36,40.5h8c0.3,0,0.5-0.2,0.5-0.5V16c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v24
		C35.5,40.3,35.7,40.5,36,40.5z M37.5,18c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v12c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V18z"
    />
    <path
      class="st1"
      d="M10,40.5h8c0.3,0,0.5-0.2,0.5-0.5V23c0-0.3-0.2-0.5-0.5-0.5h-8c-0.3,0-0.5,0.2-0.5,0.5v17
		C9.5,40.3,9.7,40.5,10,40.5z M11.5,25c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v4.5c0,0.3-0.2,0.5-0.5,0.5h-4
		c-0.3,0-0.5-0.2-0.5-0.5V25z"
    />
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st3"
      d="M44,28.8H10c-0.3,0-0.5-0.2-0.5-0.5v-10c0-0.3,0.2-0.5,0.5-0.5h34c0.3,0,0.5,0.2,0.5,0.5v10
		C44.5,28.5,44.2,28.8,44,28.8z"
    />
    <path
      class="st1"
      d="M41,22.3H9.5v-2.5H41c0.3,0,0.5,0.2,0.5,0.5v1.5C41.5,22,41.3,22.3,41,22.3z"
    />
    <path
      class="st1"
      d="M42,26.8H9.5v-2.5H42c0.3,0,0.5,0.2,0.5,0.5v1.5C42.5,26.5,42.3,26.8,42,26.8z"
    />
    <path
      class="st3"
      d="M34,41H10c-0.3,0-0.5-0.2-0.5-0.5v-9c0-0.3,0.2-0.5,0.5-0.5h24c0.3,0,0.5,0.2,0.5,0.5l0,9
		C34.5,40.8,34.2,41,34,41z"
    />
    <path
      class="st1"
      d="M32,35.2H9.5v-2.5H32c0.3,0,0.5,0.2,0.5,0.5v1.5C32.5,34.9,32.3,35.2,32,35.2z"
    />
    <path
      class="st1"
      d="M29,39.3H9.5v-2.5H29c0.3,0,0.5,0.2,0.5,0.5v1.5C29.5,39.1,29.3,39.3,29,39.3z"
    />
    <path
      class="st3"
      d="M27,16H10c-0.3,0-0.5-0.2-0.5-0.5v-10C9.5,5.2,9.7,5,10,5h17c0.3,0,0.5,0.2,0.5,0.5v10
		C27.5,15.8,27.2,16,27,16z"
    />
    <path
      class="st1"
      d="M25,9.5H9.5V7H25c0.3,0,0.5,0.2,0.5,0.5V9C25.5,9.3,25.3,9.5,25,9.5z"
    />
    <path
      class="st1"
      d="M23,14H9.5v-2.5H23c0.3,0,0.5,0.2,0.5,0.5v1.5C23.5,13.8,23.3,14,23,14z"
    />
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <g class="st5">
      <path
        class="st7"
        d="M32.7,6v34c0,0.3-0.2,0.5-0.5,0.5h-10c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h10
			C32.5,5.5,32.7,5.7,32.7,6z"
      />
      <path
        class="st6"
        d="M26.2,11v29.5h-2.5V11c0-0.3,0.2-0.5,0.5-0.5h1.5C26,10.5,26.2,10.7,26.2,11z"
      />
      <path
        class="st6"
        d="M30.7,8v32.5h-2.5V8c0-0.3,0.2-0.5,0.5-0.5h1.5C30.5,7.5,30.7,7.7,30.7,8z"
      />
      <path
        class="st7"
        d="M45,16v24c0,0.3-0.2,0.5-0.5,0.5h-9c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5l9,0
			C44.7,15.5,45,15.7,45,16z"
      />
      <path
        class="st6"
        d="M39.1,18v22.5h-2.5V18c0-0.3,0.2-0.5,0.5-0.5h1.5C38.9,17.5,39.1,17.7,39.1,18z"
      />
      <path
        class="st6"
        d="M43.3,21v19.5h-2.5V21c0-0.3,0.2-0.5,0.5-0.5h1.5C43.1,20.5,43.3,20.7,43.3,21z"
      />
      <path
        class="st7"
        d="M20,23v17c0,0.3-0.2,0.5-0.5,0.5h-10C9.2,40.5,9,40.3,9,40V23c0-0.3,0.2-0.5,0.5-0.5h10
			C19.7,22.5,20,22.7,20,23z"
      />
      <path
        class="st6"
        d="M13.5,25v15.5H11V25c0-0.3,0.2-0.5,0.5-0.5H13C13.2,24.5,13.5,24.7,13.5,25z"
      />
      <path
        class="st6"
        d="M18,27v13.5h-2.5V27c0-0.3,0.2-0.5,0.5-0.5h1.5C17.7,26.5,18,26.7,18,27z"
      />
    </g>
  </g>
  <g class="st0">
    <path
      class="st1"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st1"
      d="M27,14.5H10c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h17c0.3,0,0.5,0.2,0.5,0.5v8
		C27.5,14.3,27.3,14.5,27,14.5z"
    />
    <path
      class="st1"
      d="M34,40.5H10c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5h24c0.3,0,0.5,0.2,0.5,0.5v8
		C34.5,40.3,34.3,40.5,34,40.5z"
    />
    <path
      class="st1"
      d="M44,27.5H10c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5h34c0.3,0,0.5,0.2,0.5,0.5v8
		C44.5,27.3,44.3,27.5,44,27.5z"
    />
  </g>
  <g>
    <path
      class="st6"
      d="M47,43.5H6.5V3c0-0.3-0.2-0.5-0.5-0.5H3C2.7,2.5,2.5,2.7,2.5,3v41v3c0,0.3,0.2,0.5,0.5,0.5h3h41
		c0.3,0,0.5-0.2,0.5-0.5v-3C47.5,43.7,47.3,43.5,47,43.5z"
    />
    <path
      class="st6"
      d="M18.5,23v17c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V23c0-0.3,0.2-0.5,0.5-0.5h8
		C18.3,22.5,18.5,22.7,18.5,23z"
    />
    <path
      class="st6"
      d="M44.5,16v24c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5h8
		C44.3,15.5,44.5,15.7,44.5,16z"
    />
    <path
      class="st6"
      d="M31.5,6v34c0,0.3-0.2,0.5-0.5,0.5h-8c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h8
		C31.3,5.5,31.5,5.7,31.5,6z"
    />
  </g>
</svg>
